export default __webpack_public_path__ + "static/services-managed-services-parallax-a68289c4379c2305ec464f66b6385952.jpg";